export default __webpack_public_path__ + "static/media/chevron-up.e9ac4aeb.svg";